import * as React from 'react';
import { connect } from 'react-redux';
import { fetchCurrentStaff } from '../../actions/navHeader';
import toggleNavigation from '../../theme/dom/toggleNavigation';
import Icon from '../../theme/Icon';
import Button from '../../theme/Button';

import { objectSelector } from 'theme/utils';

class NavigationHeader extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchCurrentStaff());
  }

  getFullName(currentStaff, localCurrentRetailStore) {
    let firstName =
      objectSelector(currentStaff, 'first_name') ||
      (localCurrentRetailStore &&
        objectSelector(localCurrentRetailStore[0], 'first_name')) ||
      '';
    let lastName =
      objectSelector(currentStaff, 'last_name') ||
      (localCurrentRetailStore &&
        objectSelector(localCurrentRetailStore[0], 'last_name')) ||
      '';

    if (firstName || lastName) {
      return `${firstName} ${lastName}`;
    }
    return null;
  }

  render() {
    let localCurrentRetailStore = JSON.parse(
      localStorage.getItem('localCurrentRetailStore')
    );
    const { currentStaff } = this.props;

    const fullName = this.getFullName(currentStaff, localCurrentRetailStore);

    return (
      <div className='nav__header'>
        {fullName}
        <Button classes='nav__header-close' onClick={() => toggleNavigation()}>
          <Icon icon='carpi' />
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentStaff: state.staffs.currentStaff,
  };
};

export default connect(mapStateToProps)(NavigationHeader);



// WEBPACK FOOTER //
// ./src/components/partials/NavigationHeader.js